import type { BannerCarousel } from '@setplex/tria-api'
import type { Store } from 'effector'
import type { TFunction } from '~/core/i18n'
import type { AdjustPurchaseableFnFactory } from '~/features/payment/sse-purchases'
import type {
  FormattedBannerBundle,
  FormattedBannerCarouselList,
} from './index.h'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18nModel } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { clearFieldsBanner } from './lib'

const mapFormattedBannerCarousels = (
  banners: BannerCarousel[],
  adjust: AdjustPurchaseableFnFactory,
  { t }: { t: TFunction }
): FormattedBannerCarouselList =>
  banners.map((banner) => ({
    ...banner,
    bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust, t)) as
      | FormattedBannerBundle[]
      | undefined,
  }))

// movies + tv + shows. Used on home page
export const $bannersFilledFormatted: Store<BannerCarousel[]> = combine(
  api.banners.$banners,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust, { t }): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust, t)),
    }))
)

// shows
export const $bannersTypeShowFormatted: Store<FormattedBannerCarouselList> =
  combine(
    api.banners.$bannersTypeTvShow,
    ssePurchasesModel.$adjust,
    i18nModel.$t,
    mapFormattedBannerCarousels
  )

// movies
export const $bannersTypeVodFormatted: Store<FormattedBannerCarouselList> =
  combine(
    api.banners.$bannersTypeVod,
    ssePurchasesModel.$adjust,
    i18nModel.$t,
    mapFormattedBannerCarousels
  )

// tv
export const $bannersTypeTvFormatted: Store<BannerCarousel[]> = combine(
  api.banners.$bannersTypeTv,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust, { t }): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust, t)),
    }))
)
